type Pos = { x: number; y: number };
type NodeLike = { id: string; position: Pos; width?: number; height?: number };

const DEFAULT_W = 316;   
const DEFAULT_H = 211;
const PADDING = 24;

const rect = (n: NodeLike) => {
  const w = n.width ?? DEFAULT_W;
  const h = n.height ?? DEFAULT_H;
  return { x1: n.position.x, y1: n.position.y, x2: n.position.x + w, y2: n.position.y + h };
};

const intersects = (a: ReturnType<typeof rect>, b: ReturnType<typeof rect>) => {
  return !(a.x2 + PADDING < b.x1 || a.x1 > b.x2 + PADDING || a.y2 + PADDING < b.y1 || a.y1 > b.y2 + PADDING);
};

export const computeAnchor = (nodes: NodeLike[], dependencies: string[]): Pos => {
  const byId = new Map(nodes.map(n => [n.id, n]));
  const refs = dependencies.map(id => byId.get(id)).filter(Boolean) as NodeLike[];
  const base = refs.length ? refs : nodes;

  if (!base.length) {return { x: 0, y: 0 };}

  const sx = base.reduce((acc, n) => acc + n.position.x, 0);
  const sy = base.reduce((acc, n) => acc + n.position.y, 0);
  return { x: sx / base.length, y: sy / base.length };
};

export const findFreePosition = (nodes: NodeLike[], anchor: Pos): Pos => {
  const maxTries = 500;
  const step = 40;

  for (let k = 0; k < maxTries; k++) {
    const angle = k * 0.6;              
    const r = step * Math.sqrt(k);      
    const candidate: Pos = {
      x: Math.round(anchor.x + r * Math.cos(angle)),
      y: Math.round(anchor.y + r * Math.sin(angle)),
    };

    const candRect = { x1: candidate.x, y1: candidate.y, x2: candidate.x + DEFAULT_W, y2: candidate.y + DEFAULT_H };

    let ok = true;
    for (const n of nodes) {
      if (intersects(candRect, rect(n))) { ok = false; break; }
    }
    if (ok) {return candidate;}
  }

  return { x: anchor.x + 300, y: anchor.y + 0 };
};
